import { Injectable } from '@angular/core';
import { ObjectHelper } from '@barthauer/abc/core';
import { Observable } from 'rxjs';
import { AbcCoreDataModule } from './abc-core-data.module';
import { DataService } from './data.service';
import { QueryObjectsModel, QueryParameter, ReadListDataSourceModel } from './models/query.model';

@Injectable({
  providedIn: AbcCoreDataModule,
})
export class QueryService {
  constructor(private data: DataService) {}

  public readObjects(query: QueryObjectsModel, idList?: string[]): Observable<ArrayBuffer> {
    if (idList?.length) {
      query = ObjectHelper.cloneDeep(query);
      if (!query.Parameters) {
        query.Parameters = [];
      }

      if (idList.length === 1) {
        for (let q of query.ObjectQueries) {
          q.OPath = 'Id = $IdDynamic';
        }
        query.Parameters.push(new QueryParameter('IdDynamic', idList[0]));
      } else {
        for (let q of query.ObjectQueries) {
          q.OPath = 'Id In ($IdListDynamic)';
        }
        query.Parameters.push(new QueryParameter('IdListDynamic', idList));
      }
    }
    return this.data.executeReadObjectsQuery(query);
  }

  public readListDataSource(query: ReadListDataSourceModel): Observable<ArrayBuffer> {
    return this.data.executeReadListDataSource(query);
  }
}
